import { FC } from 'react';
import { useHistory } from 'react-router';

import { useAlert, useApi, useFetchData } from '@app/hooks';
import { QueryTable } from '@app/components/common/table';
import { OutletHistoryItem } from '@app/api/models';

import { useColumns } from './columns';

const HistoryTable: FC = () => {
  const api = useApi();
  const [fetchData] = useFetchData<OutletHistoryItem>({ method: api.acb.getHistory });
  const { error, warning } = useAlert();
  const history = useHistory();


  const onUpdateRequestClick = async (id: string) => {
    console.log(id);
    
    const updateRequests = await api.acb.getUpdates({
      filter: {
        id,
      },
      sort: '+id',
      offset: 0,
      limit: 1,
    });

    if (updateRequests.code !== 200) {
      error(updateRequests.message);
      return;
    }
    if (updateRequests.data.data.length === 0) {
      warning('Заявка на изменение ТТ не найдена');
      return;
    }

    history.push(`/acl/updates-outlets/${updateRequests.data.data[0].outlet_id}/view`, {
      update: updateRequests.data.data[0],
    });
  };
  const columns = useColumns({ onUpdateRequestClick });

  return (
    <>
      <QueryTable<OutletHistoryItem>
        title="История изменений ТТ"
        columns={columns}
        fetchData={fetchData}
        canDownload
      />
    </>
  );
};

export default HistoryTable;
